export default function cleanString(str) {
  if (!str) return ''
  return (
    str
      .replace(/\\/gm, '') // Remove backslashes
      .replace(/(?<!\\)"/gm, '') // Remove unescaped double quotes
      // .replace(/[\u0000-\u001F\u007F]/gm, '') // Remove control characters
      .replace(/[<>]/gm, '') // Remove angle brackets
      .replace(/&/gm, '') // Remove ampersands
      // .replace(/%/g, '') // Remove percentage symbols
      // .replace(/\?/g, '') // Remove question marks
      // .replace(/,/g, '') // Remove commas
      .replace(/[\{\}\[\]]/gm, '') // Remove curly and square braces
      .replace(/`/gm, '') // Remove backticks
      .replace(/(&quot;|")/gm, '') // Remove "
      .replace(/\n/g, ' ') // Replace newlines with a space
      .replace(/\t/g, ' ') // Replace tabs with a space
      .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
      .trim()
  )
}
